






















import Vue from 'vue'
import { TimePicker } from 'element-ui'
import { Component, Prop } from 'vue-property-decorator'
import DatePicker from './base/DatePicker.vue'
import FormItem from './FormItem.vue'
import { CommonBase } from './form-component-props'

@Component({
  name: 'JsfDateTimeRangePicker',
  components: {
    DatePicker,
    TimePicker,
    FormItem,
  },
})
export default class JsfDateTimeRangePicker extends CommonBase {
  @Prop() schema: any
  @Prop() type: any
  handleChange(v: any) {
    this.$emit('input', v)
  }

  get startPlaceholder() {
    return this.schema.startPlaceholder || '开始时间'
  }

  get endPlaceholder() {
    return this.schema.endPlaceholder || '结束时间'
  }

  get isTimeRange() {
    return this.type === 'timerange'
  }

  get additionProps() {
    return (this.schema.vjsf && this.schema.vjsf.additionProps) || {}
  }
}
